export const environment = {
  displayTag: "Prod",
  publicApiUrl: "https://public.api.researchallofus.org",
  researchAllOfUsUrl: "https://researchallofus.org",
  debug: false,
  gaId: "UA-116298798-6",
  gtmId: "GTM-NQ9XDTW",
  gtmAuth: "ixtwsbMAbR3hx5st_ek2jg",
  gtmPreview: "env-65",
  ehrReact: true,
  testReact: false,
  geno: true,
  genoFilters: true,
  fitbitCDRUpdate: true,
  infiniteSrcoll: true,
  svVCFBrowser: false,
  heatmap: false,
  combinedAgeGenderChart: false,
};
